import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { Button } from 'core/components';
import { useAgGridClientTableContext, useNotificationContext } from 'core/states';
import { IJob } from 'jobs/types';
import { Color, Variant } from 'theme/enums';

import { ImportBom } from './ImportBom';

interface IProps {
  job: IJob;
}

export const ImportBomButton = ({ job }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const queryClient = useQueryClient();
  const { isDataLoadCompleted } = useAgGridClientTableContext();
  const { isLoadingTopNotificationDisplayed } = useNotificationContext();

  const onSubmitSuccess = () => {
    queryClient.invalidateQueries('jobParts');
  };

  return (
    <>
      <Button
        text={t('buttonLabelImport')}
        variant={Variant.SOFT}
        color={Color.PRIMARY}
        onClick={() => setIsOpen(true)}
        disabled={!isDataLoadCompleted || isLoadingTopNotificationDisplayed}
      />

      <ImportBom
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        job={job}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
